import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreateParaphrase from "../paraphrase/CreateParaphrase"
import IndexLayout from "../../../layout/IndexLayout"
// import index from "../../../data/index"


const Main = ({ match }) => (
  <div className="dashboard-wrapper">
    <IndexLayout>
      <Switch>
        <Route path={`${match.url}/`} component={CreateParaphrase} />
      </Switch>
      {/* {index.map(item => (
        <div>
          <div className="separator mt-5" />
          <h2 className="title mt-3 ml-5">{item.title}</h2>
          <p className="subtitle ml-5">{item.text}</p>
        </div>
      ))} */}
    </IndexLayout>
  </div>
)
export default Main
